export enum AccessPageEvent {
    AccessLandingPage = 'AccessPage.AccessLandingPage',
}
